import React from 'react';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/images/arrow-left.svg';

import {
  BackIconWrapper, Wrapper
} from './styles';
import {StyledTitle} from "../../CustomAntdComponents/Typography";


type Props = {
  navigateHandler: () => void
}
function PaymentMobileHeader({ navigateHandler }: Props) {
  return (
      <>
        <Wrapper>
          <BackIconWrapper onClick={navigateHandler}>
            <ArrowLeftIcon width={20} height={20} />
          </BackIconWrapper>

          <div style={{ flex: 1 }}>
              <StyledTitle align="center" level={4}>
                  Make payment
              </StyledTitle>
          </div>
        </Wrapper>
      </>
  );
}

export default PaymentMobileHeader;
